import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SERVICE_LISTING,
    GET_SERVICE_DETAILS,
    ADD_SERVICE,
    UPDATE_SERVICE,
    DELETE_SERVICE,
    BULK_DELETE_SERVICE,
    EXPORT_SERVICE,
} from "./actionTypes.js";

import {
    getServiceListingSuccess,
    getServiceListingFail,
    createServiceSuccess,
    createServiceFail,
    updateServiceSuccess,
    updateServiceFail,
    deleteServiceSuccess,
    deleteServiceFail,
    bulkDeleteServiceSuccess,
    bulkDeleteServiceFail,
    exportServiceSuccess,
    exportServiceFail,
    getServiceDetailsSuccess,
    getServiceDetailsFail,
} from "./actions.js";

import {
    serviceListingApi,
    updateServiceApi,
    deleteServiceApi,
    bulkDeleteServiceApi,
    exportServiceApi,
    serviceDetailsApi,
    addServiceApi,
} from "./serviceApi.js";

function* fetchServiceListing({ payload }) {
    try {
        const response = yield call(serviceListingApi, payload);
        yield put(getServiceListingSuccess(response));
    } catch (error) {
        yield put(getServiceListingFail(error));
    }
}

function* fetchServiceDetail({ payload }) {
    try {
        const response = yield call(serviceDetailsApi, payload);
        yield put(getServiceDetailsSuccess(response));
    } catch (error) {
        yield put(getServiceDetailsFail(error));
    }
}

function* createService({ payload }) {
    try {
        const response = yield call(addServiceApi, payload);
        yield put(createServiceSuccess(response));
    } catch (error) {
        yield put(createServiceFail(error));
    }
}

function* updateService({ payload }) {
    try {
        const response = yield call(updateServiceApi, payload);
        yield put(updateServiceSuccess(response));
    } catch (error) {
        yield put(updateServiceFail(error));
    }
}

function* deleteService({ payload }) {
    try {
        const response = yield call(deleteServiceApi, payload);
        yield put(deleteServiceSuccess(response));
    } catch (error) {
        yield put(deleteServiceFail(error));
    }
}

function* bulkDeleteService({ payload }) {
    try {
        const response = yield call(bulkDeleteServiceApi, payload);
        yield put(bulkDeleteServiceSuccess(response));
    } catch (error) {
        yield put(bulkDeleteServiceFail(error));
    }
}

function* exportService({ payload }) {
    try {
        const response = yield call(exportServiceApi, payload);
        yield put(exportServiceSuccess(response));
    } catch (error) {
        yield put(exportServiceFail(error));
    }
}

function* ServiceSaga() {
    yield takeEvery(GET_SERVICE_LISTING, fetchServiceListing);
    yield takeEvery(GET_SERVICE_DETAILS, fetchServiceDetail);
    yield takeEvery(ADD_SERVICE, createService);
    yield takeEvery(UPDATE_SERVICE, updateService);
    yield takeEvery(DELETE_SERVICE, deleteService);
    yield takeEvery(BULK_DELETE_SERVICE, bulkDeleteService);
    yield takeEvery(EXPORT_SERVICE, exportService);

}

export default ServiceSaga
